import { createAction } from 'redux-actions';
import {
	GET_PERSONAL_PAYROLL_DETAIL_CALL,
	GET_PERSONAL_PAYROLL_DETAIL_DONE,
	GET_PERSONAL_PAYROLL_DETAIL_FAIL,
	GET_PERSONAL_PAYROLL_LIST_CALL,
	GET_PERSONAL_PAYROLL_LIST_DONE,
	GET_PERSONAL_PAYROLL_LIST_FAIL,
} from '@src/store/types/payroll';

export const getPersonalPayrollListCall = createAction(GET_PERSONAL_PAYROLL_LIST_CALL);
export const getPersonalPayrollListDone = createAction(GET_PERSONAL_PAYROLL_LIST_DONE);
export const getPersonalPayrollListFail = createAction(GET_PERSONAL_PAYROLL_LIST_FAIL);

export const getPersonalPayrollDetailCall = createAction(GET_PERSONAL_PAYROLL_DETAIL_CALL);
export const getPersonalPayrollDetailDone = createAction(GET_PERSONAL_PAYROLL_DETAIL_DONE);
export const getPersonalPayrollDetailFail = createAction(GET_PERSONAL_PAYROLL_DETAIL_FAIL);
